<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <UserProfile />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <DashbordTab />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { POST_API, GET_API } from "../store/actions.type";
  import ApiService from "../api/api.service";
  import UserProfile from './Dashboards/UserProfile.vue';
  import DashbordTab  from './Dashboards/DashbordTab.vue';
  import JwtService from "./common/jwt.service";
  export default {
    components: {
         UserProfile,
         DashbordTab,
    },
    data: () => ({
      //
    }),
    methods: {

    }
  };
</script>